import classNames from 'classnames';
import { memo, useMemo } from 'react';

import { SparklesIcon } from '@air/design-icons';

import { useEditModeBoundingBox } from '~/components/EditMode/hooks/useEditModeBoundingBox';
import { useEditModeOptions } from '~/components/EditMode/hooks/useEditModeOptions';

export const EditModeTransformationHintBanner = memo(() => {
  const { currentEditModeOption } = useEditModeOptions();
  const { boundingBox } = useEditModeBoundingBox();

  const bannerText = useMemo(() => {
    if (currentEditModeOption?.id === 'removeObject') {
      return 'Draw a rectangle around the areas on the image to erase using AI.';
    }
    if (currentEditModeOption?.id === 'crop') {
      return 'Draw a rectangle to select the area you want to crop.';
    }

    return null;
  }, [currentEditModeOption]);

  return (
    <div
      className={classNames(
        'absolute bottom-24 left-1/2 z-10 -translate-x-1/2 transition-opacity duration-500',
        boundingBox.show && !boundingBox.box ? 'opacity-100' : 'opacity-0',
      )}
    >
      <div className="rounded-8 ads:bg-primary-subtle bg-blue-4 px-3 py-2.5">
        <div className="flex items-center gap-2">
          <SparklesIcon className="ads:text-icon-primary text-blue-11" size="sm" />
          <span className="font-medium ads:text-accent text-14 text-blue-12">{bannerText}</span>
        </div>
      </div>
    </div>
  );
});

EditModeTransformationHintBanner.displayName = 'EditModeTransformationHintBanner';
